import {
  formatAccountRepDisplayName,
  formatAccountRepPhotoFilename,
  formatPhoneNumber,
} from "./util/stringUtil";

import { ACCOUNT_REP_PHOTOS_URL } from "../constants";
import { GET_SALES_REP } from "./CustomerServicePopup";
import { Loading } from "@verse_core/shared_components/base/Loading";
import { handleVmGraphQLErrors } from "./util/httpRequestUtil";
import { selectHospitalId } from "../../../src/redux/app";
import { useAppSelector } from "../../../src/redux/hooks";
import { useQuery } from "@apollo/client";

export const AccountRepresentativeContactCard = () => {
  const hospitalId = useAppSelector(selectHospitalId);
  const {
    loading,
    error,
    data: salesRepData,
  } = useQuery(GET_SALES_REP, {
    fetchPolicy: "no-cache",
    variables: {
      hospitalId: hospitalId ?? 0,
    },
    skip: !hospitalId,
  });

  const salesRep = salesRepData?.getAccountRep;

  if (loading) return <Loading />;
  if (error) return handleVmGraphQLErrors(error.message);
  // No assigned rep (e.g. Arsy-assigned accounts, which getAccountRep hides):
  // hide the card rather than surfacing a "no sales rep" error to the provider.
  if (!salesRep) return null;

  return (
    <div className="tw-mt-[35px]">
      <h5 className="tw-font-dm-sans tw-uppercase tw-tracking-[0.08em] tw-text-blue-1">
        Your account representative
      </h5>
      <div className="tw-flex tw-flex-row tw-rounded-md tw-border-[0.5px] tw-border-solid tw-border-gray-5 tw-bg-gray-light-4 tw-p-[10px]">
        <div className="tw-p-[10px] tw-py-[25px]">
          <img
            className="tw-h-[95px] tw-w-[95px] tw-rounded-full tw-object-cover"
            src={`${ACCOUNT_REP_PHOTOS_URL}/${formatAccountRepPhotoFilename(salesRep.name)}`}
          />
        </div>
        <div className="tw-px-[10px]">
          <h3>{formatAccountRepDisplayName(salesRep.name)}</h3>
          <a href={`tel:${salesRep.phone}`}>
            <div className="tw-inline-block tw-rounded-md tw-border-[0.5px] tw-border-solid tw-border-blue-1 tw-bg-blue-light-1 tw-p-[8px] tw-text-blue-1">
              <i className="fas fa-phone" />{" "}
              <b>{formatPhoneNumber(salesRep.phone ?? "")}</b>
            </div>
          </a>
          <a href={`mailto:${salesRep.email}`}>
            <div className="tw-my-[3px] tw-block tw-w-fit tw-rounded-md tw-border-[0.5px] tw-border-solid tw-border-blue-1 tw-bg-blue-light-1 tw-p-[8px] tw-text-blue-1">
              <i className="fas fa-envelope" /> <b>{salesRep.email}</b>
            </div>
          </a>
          <p className="tw-mt-[3px]">
            In case you don't connect immediately, please leave a voicemail and
            you will be called back right away.
          </p>
        </div>
      </div>
    </div>
  );
};
